import { Directive, HostListener, Input } from '@angular/core';
import { KlevuTrackService } from '@df/module-klevu-search/klevu-track.service';
import { KlevuSearch } from './klevu-interfaces';

@Directive({
    selector: '[klevuTrackCategoryProductClick]',
    standalone: true
})
export class KlevuTrackCategoryProductClickDirective {
    @Input({
        required: true
    })
    klevuTrackCategoryProductClick!: KlevuSearch.ITrackCategoryProductClickData;

    constructor(private klevuTrackService: KlevuTrackService) {}

    @HostListener('click')
    onClick() {
        if (this.klevuTrackCategoryProductClick) {
            this.klevuTrackService.trackCategoryProductClick(this.klevuTrackCategoryProductClick);
        }
    }
}
